import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { GMapsMultipleMarkerComponent } from '@/components/reusable/GMapsComponent/GMapsMultipleMarkerComponent';
import { NewHeaderSearchComponent } from '@/components/general/NewSearchComponent';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import { Navigation, Autoplay } from 'swiper/modules';
import { useSelector } from 'react-redux';
import { useMobileDetection } from '@/hooks/DetectionMobile.hook';
import ReactPixel from 'react-facebook-pixel';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import NewSpaceCardBlueVersion from '@/components/reusable/NewSpaceCardBlueVersion/NewSpaceCardBlueVersion';
import AuthModal from '@/components/pages/WorkspaceMap/components/Modals/AuthModal';
import WarningModal from '@/components/pages/WorkspaceMap/components/Modals/WarningModal';
import './WorkspaceMapView.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const WorkspaceMapView = props => {
  const {
    workspacesDataFromBackend,
    isSignInModalIsOpen,
    closeSignInModal,
    closeWarningModal,
    isWarningModalIsOpen,
    coordinatesForMapCenter,
    onClickMarkers,
    onSwiperInit,
    onGoogleLogin,
  } = props;

  const deviceInfo = useMobileDetection();
  console.log(isSignInModalIsOpen, 'props aqui desde workspace');
  const [mapKeyCounter, setMapKeyCounter] = useState(0);
  const [smallPins, setSmallPins] = useState(true);

  const loggedUser = useSelector(state => state.user);

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log('=== ESPECIFICACIONES DEL DISPOSITIVO ===');
    console.log('Sistema operativo:', deviceInfo.os);
    console.log('Versión del SO:', deviceInfo.osVersion);
    console.log('Navegador:', deviceInfo.browser);
    console.log('Versión del navegador:', deviceInfo.browserVersion);
    console.log('Fabricante:', deviceInfo.deviceVendor);
    console.log('Modelo:', deviceInfo.deviceModel);
    console.log('Tipo de dispositivo:', deviceInfo.deviceType);
    console.log('Es móvil:', deviceInfo.isMobile);
    console.log('Es tablet:', deviceInfo.isTablet);
    console.log('Es desktop:', deviceInfo.isDesktop);
    console.log('Es táctil:', deviceInfo.isTouchDevice);
    console.log('Idioma:', deviceInfo.language);
    console.log('Zona horaria:', deviceInfo.timezone);
    console.log('=====================================');
  }, [deviceInfo]);

  const languageData = useSelector(state => state.lenguage?.lang);
  const currentSearchFormData = useSelector(state => state.searchFormData);
  const navigate = useNavigate();
  const esDescription = 'Esta es la lista de espacios disponibles en Popnest.';
  const enDescription = 'This is the list of available spaces on Popnest.';

  const goToSpaceDetails = spaceData => {
    ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate(
      languageData === 'ES'
        ? '/confirmar-reservacion2nd/' +
            spaceData?.relationship_title +
            '/' +
            spaceData?.id_relationship
        : '/confirm-reservation2nd/' +
            spaceData?.relationship_title +
            '/' +
            spaceData?.id_relationship,
      {
        state: { spaceData },
      },
    );
  };

  return (
    <FlexContainer className={'flex-column width100'}>
      <HelmetComponent
        title={
          languageData === 'EN' ? 'Spaces - Popnest' : 'Espacios - Popnest'
        }
        description={languageData === 'EN' ? enDescription : esDescription}
        graphTitle={
          languageData === 'EN' ? 'Spaces - Popnest' : 'Espacios - Popnest'
        }
        graphDescription={languageData === 'EN' ? enDescription : esDescription}
      />
      <>
        <FlexContainer
          className="flex-column align-center justify-center width100"
          style={{
            overflow: 'hidden',
          }}
        >
          <NewHeaderSearchComponent />
          <GMapsMultipleMarkerComponent
            smallPins={smallPins}
            setSmallPins={setSmallPins}
            mapKeyCounter={mapKeyCounter}
            setMapKeyCounter={setMapKeyCounter}
            center={{
              space_latitude: String(coordinatesForMapCenter?.lat),
              space_logitude: String(coordinatesForMapCenter?.lng),
            }}
            lenguage={languageData}
            markers={workspacesDataFromBackend}
            onClickMarkers={onClickMarkers}
            customHeight={'660px'}
          />
        </FlexContainer>
        <FlexContainer
          className="flex-column align-center justify-center width100 pos-abs"
          style={{
            marginTop: '100%',
          }}
        >
          <Swiper
            key={mapKeyCounter}
            className={'width100'}
            spaceBetween={20}
            slidesPerView={1.4}
            pagination={{ clickable: true }}
            modules={[Navigation, Autoplay]}
            loop={false}
            speed={50}
            onAutoplay={() => {}}
            onSwiper={onSwiperInit}
          >
            {Array.isArray(workspacesDataFromBackend) &&
              workspacesDataFromBackend.slice(0, 50).map((space, index) => (
                <SwiperSlide key={index}>
                  <NewSpaceCardBlueVersion
                    key={index}
                    spaceInfo={space}
                    handleDetailButton={() => goToSpaceDetails(space)}
                    priceAndCapacityDetails
                    categoriesPills
                    isLightGradientBlueVersion
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </FlexContainer>

        <FlexContainer className="flex-column align-center justify-center margb40 padlr10 gap-6">
          {Array.isArray(workspacesDataFromBackend) &&
            workspacesDataFromBackend
              .slice(0, 50)
              .map((space, index) => (
                <NewSpaceCardBlueVersion
                  key={index}
                  spaceInfo={space}
                  handleDetailButton={() => goToSpaceDetails(space)}
                  priceAndCapacityDetails
                  isActive={true}
                  categoriesPills
                  isLightGradientBlueVersion
                  isCarousel
                />
              ))}
          {!loggedUser && (
            <AuthModal
              isOpen={isSignInModalIsOpen}
              onClose={closeSignInModal}
              languageData={languageData}
              onGoogleLogin={onGoogleLogin}
            />
          )}
        </FlexContainer>
        <WarningModal
          isOpen={isWarningModalIsOpen}
          onClose={closeWarningModal}
          languageData={languageData}
        />
      </>
    </FlexContainer>
  );
};

export default WorkspaceMapView;
